import React, { useEffect, useState } from "react";
import ContactForm from "@/components/ContactForm";
import SEO, { faqPageSchema } from "@/components/SEO";
import { api } from "@/api/client";
import { CONTACT } from "@/config/contact";
import { Phone, Mail, MapPin, MessageCircle, Instagram, Facebook } from "lucide-react";

export default function ContactoPage() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);

  const faqSchema = faqPageSchema(faqs);

  return (
    <div data-testid="page-contacto">
      <SEO
        title="Contacto — Falar com a Zélia Silva"
        description="Fale com a Zélia Silva, consultora imobiliária no Porto e Grande Porto. Telefone, WhatsApp, email ou formulário. Resposta no próprio dia útil."
        canonical="https://casanoporto.com/contacto"
        jsonLd={faqSchema ? [faqSchema] : undefined}
      />
      <section className="container-cnp pt-14 lg:pt-20 pb-10">
        <div className="max-w-3xl">
          <span className="tag-chip">Contacto</span>
          <h1 className="mt-4 font-display text-4xl md:text-5xl text-stone-900">Vamos marcar uma reunião sobre a sua casa.</h1>
          <p className="mt-4 text-stone-600">Deixe uma mensagem ou ligue diretamente. Respondo no próprio dia útil, com clareza e sem compromisso.</p>
        </div>
      </section>

      <section className="container-cnp pb-16 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5 space-y-4">
          <div className="card-soft p-6 flex items-start gap-4">
            <div className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#103C4A]/10 text-[#103C4A]"><Phone className="h-5 w-5" /></div>
            <div>
              <div className="text-xs uppercase tracking-widest text-stone-500">Telefone / WhatsApp</div>
              <a href={`tel:${CONTACT.phoneRaw}`} data-testid="contacto-phone" className="text-lg font-medium text-stone-900 link-underline">{CONTACT.phone}</a>
              <div className="mt-2">
                <a href={CONTACT.whatsappUrl} target="_blank" rel="noreferrer" data-testid="contacto-whatsapp" className="inline-flex items-center gap-2 text-sm text-[#103C4A] link-underline">
                  <MessageCircle className="h-4 w-4" /> Enviar mensagem via WhatsApp
                </a>
              </div>
            </div>
          </div>
          <div className="card-soft p-6 flex items-start gap-4">
            <div className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#103C4A]/10 text-[#103C4A]"><Mail className="h-5 w-5" /></div>
            <div>
              <div className="text-xs uppercase tracking-widest text-stone-500">Email</div>
              <a href={`mailto:${CONTACT.email}`} data-testid="contacto-email" className="text-lg font-medium text-stone-900 link-underline">{CONTACT.email}</a>
            </div>
          </div>
          <div className="card-soft p-6 flex items-start gap-4">
            <div className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#103C4A]/10 text-[#103C4A]"><MapPin className="h-5 w-5" /></div>
            <div>
              <div className="text-xs uppercase tracking-widest text-stone-500">Zona</div>
              <div className="text-lg font-medium text-stone-900">Porto e Grande Porto</div>
              <div className="text-sm text-stone-600">Porto · Gondomar · Maia · Ermesinde · Valongo</div>
            </div>
          </div>
          <div className="card-soft p-6">
            <div className="text-xs uppercase tracking-widest text-stone-500 mb-3">Redes sociais</div>
            <div className="flex items-center gap-3">
              <a href={CONTACT.instagram} target="_blank" rel="noreferrer" data-testid="contacto-instagram" className="inline-flex items-center gap-2 rounded-full border border-stone-200 px-4 py-2 text-sm text-stone-700 hover:text-[#103C4A] hover:border-[#103C4A]"><Instagram className="h-4 w-4" /> Instagram</a>
              <a href={CONTACT.facebook} target="_blank" rel="noreferrer" data-testid="contacto-facebook" className="inline-flex items-center gap-2 rounded-full border border-stone-200 px-4 py-2 text-sm text-stone-700 hover:text-[#103C4A] hover:border-[#103C4A]"><Facebook className="h-4 w-4" /> Facebook</a>
            </div>
          </div>
        </div>
        <div className="lg:col-span-7 card-soft p-8">
          <ContactForm testidPrefix="contacto" />
        </div>
      </section>

      {faqs.length > 0 && (
        <section className="container-cnp pb-24">
          <span className="tag-chip">Perguntas frequentes</span>
          <h2 className="mt-4 font-display text-3xl md:text-4xl text-stone-900">Dúvidas que quase todos os clientes têm.</h2>
          <div className="mt-10 grid md:grid-cols-2 gap-5">
            {faqs.map((f) => (
              <div key={f.id} data-testid={`contacto-faq-${f.id}`} className="card-soft p-6">
                <div className="text-xs uppercase tracking-widest text-stone-500">{f.category}</div>
                <div className="mt-2 font-medium text-stone-900">{f.question}</div>
                <div className="mt-2 text-stone-600 text-sm">{f.answer}</div>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
